import { DialogComponentContent } from './../../../../models/dialogs/DialogComponentContent';
import { Component, ElementRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppState } from '../../../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

@Component({
    selector: 'confirm-with-options',
    templateUrl: './confirm-with-options.component.html',
    styleUrls: ['./confirm-with-options.component.scss'],
})

export class ConfirmWithOptionsComponent extends DialogComponentContent {

    public radioSelected: any = null;
    public subject: Subject<any> = new Subject();

    public title: string = '';
    public content: string = '';
    public options: any[] = [];
    public confirmButton: string = '';
    public cancelButton: string = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ConfirmWithOptionsComponent>,
        private router: Router,
        private store: Store<AppState>,
        element: ElementRef,
    ) {
        super(element);
    }

    public dispose(action) {

        if (action) {
            if (this.radioSelected) {
                this.subject.next(this.radioSelected);
            } else {
                this.subject.next(null);
                return;
            }
        }

        if (!action) {
            this.subject.next(null);
        }

        this.subject.complete();
        this.dialogRef.close(null);
    }
}
